import { summaryFieldOptions } from '~domains/dashboard/widgets/summary-graph';
import type { SummaryDataField } from '~domains/dashboard/widgets/summary-graph';

import { useIsDesktop } from '~shared/lib/responsive';
import { MobileSelect } from '~shared/ui/mobile-select';

import { Chips } from '@breezeventures/ui-kit/chips';

type Props = {
  value: SummaryDataField;
  onChange: (value: SummaryDataField) => void;
};

export const MetricChips = ({ value, onChange }: Props) => {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return (
      <MobileSelect
        options={summaryFieldOptions}
        value={value}
        onChange={onChange}
      />
    );
  }

  return (
    <Chips
      type="single"
      variant="soft"
      size="m"
      value={value}
      onChange={(next) => onChange(next as SummaryDataField)}
    >
      {summaryFieldOptions.map((option) => (
        <Chips.Item key={option.value} value={option.value}>
          {option.label}
        </Chips.Item>
      ))}
    </Chips>
  );
};
